import './footer.css'
import logo from '../../assets/company/2.svg'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer(){
    const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 767);

    useEffect(() => {
        function handleResize() {
            setMobileVersion(window.innerWidth <= 767);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    return(
        <footer>
            <div className={mobileVersion ? 'mob-footer-header' : 'footer-header'}>
                <div className={mobileVersion ? '' : 'left'}>
                    <div className="logo">
                    <img 
                            src={logo} 
                            alt="Company Logo" 
                            className="logo-svg" 
                        />
                    </div>
                    <div className="about">
                        <p>CAE Company is a globally trusted and reliable partner for executive search and high-impact talent acquisition across multiple industries.</p>
                    </div>
                </div>
                <div className={mobileVersion ? '' : 'right'}>
                <p>Navigation</p>
                <ul className="navigation">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/executivesearch">Executive Search</Link></li>
                    <li><Link to="/services">Services</Link></li>
                    <li><Link to="/about">About us</Link></li>
                    <li><Link to="/contact">Contact us</Link></li>
                    <li><Link to="/imprint">Imprint</Link></li>
                </ul>
                </div>
            </div>
           
        </footer>
    );
}